'use client'
import React, { useState, useEffect, useContext } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import useScreenWidth from '@/hooks/useScreenWidth'
import { useRouter } from 'next/navigation'
const Template04 = (props: any) => {
  const screenWidth = useScreenWidth()
  const router = useRouter()

  const Navigate = (link: string, type: any) => {
    if (type === 'external_link') {
      window.open(link, '_blank')
    } else {
      router.push(link)
    }
  }
  return (
    <>
      {props.data !== undefined && (
        <section className="our-collection-section">
          <div className="container">
            <div className="main-title-section text-center">
              <b className="sub-title-heading">{props.data.subtitle}</b>
              <h2 className="main-title-heading">{props.data.name}</h2>
            </div>
          </div>
          <div className="our-collection-slider">
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
            <Swiper
              effect="fade"
              slidesPerView={3}
              modules={[Navigation, Autoplay]}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              }}
              loop={true}
              autoplay={false}
              // autoplay={{
              //   delay: 1500
              // }}
              speed={800}
              spaceBetween={30}
              breakpoints={{
                300: {
                  slidesPerView: 1
                },
                768: {
                  slidesPerView: 2
                },
                991: {
                  slidesPerView: 3
                },
                1025: {
                  slidesPerView: 3
                },
                1200: {
                  slidesPerView: 3
                },
                1300: {
                  slidesPerView: 3
                }
              }}
            >
              {props.data.section_items.map((item: any, itemIndex: number) => (
                <SwiperSlide key={itemIndex}>
                  <div
                    className="collection-product-repeat"
                    key={itemIndex}
                  >
                    <span
                      onClick={(e) => Navigate(item.link, item.type)}
                      className="collection-product-link"
                    >
                      <div className="collection-product-img">
                        <img
                          src={screenWidth > 768 ? item.desktop_image : item.mobile_image}
                          alt="product"
                        />
                      </div>
                      <div className="collection-product-title">
                        <h3 className="collection-product-name">{item.title}</h3>
                      </div>
                    </span>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>
      )}
    </>
  )
}
export default Template04
